/* import ApiService from "./api.service" */
import ApiMockService from "./api.mock.service";

/**
 *  FormatsService es un objeto que almacena las funciones
 */

const FormatsService = {
  getFormats: async function (lang = null) {
    const response = await ApiMockService.get("api/admin/supplements/formats", lang);
    // Temporal Local Storage: start
    const itemLS = localStorage.getItem("formats");
    let formatsLS = [];
    if (itemLS) {
      try {
        console.log("Parsing formats from localStorage", itemLS);
        formatsLS = JSON.parse(itemLS);
      } catch (error) {
        console.error("Error parsing formats from localStorage:", error);
        formatsLS = [];
      }
    }
    const allFormats = [...formatsLS, ...(response.data ?? [])];
    return allFormats;
    // Temporal Local Storage: end
    // return response.data ?? [];
  },
};

export default FormatsService;
